module.exports = __webpack_public_path__ + "static/media/energy9.77a1d810.jpeg";